// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"8":"75e59343","24":"392ac90c","71":"655fe029","249":"00cdcac5"}[chunkId] + ".js";
};